import { Component, Vue } from "vue-property-decorator";

@Component
export default class QueryMixin extends Vue {
  public updateRoute({ query }) {
    this.$router
      .replace({
        query
      })
      .catch(() => {
        // Mask error
      });
  }

  public addQueryParam({ key, value }) {
    const query = { ...this.$route.query };
    query[key] = value;
    this.updateRoute({ query });
  }

  public removeQueryParam(key) {
    const query = { ...this.$route.query };
    if (this.$_.has(query, key))
      this.updateRoute({ query: this.$_.omit(query, [key]) });
  }

  public qetQueryParam(key) {
    return this.$route.query[key];
  }

  // Parse from query param
  public parseQueryParamToDate(value: string, format = "YYYY-MM-DD"): Date {
    const mDate = this.$moment(value, format);
    return mDate.isValid() ? mDate.toDate() : new Date();
  }

  // Parse to query param
  public parseDateToQueryParam(value: Date, format = "YYYY-MM-DD"): string {
    return this.$moment(value).format(format);
  }
}
